import { memo } from 'react';
import { TableInput } from '../../../../../components/common';
import lodash from 'lodash';
import {
  CustomIconButton,
  DeleteIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import PickPartUi from '../../../../../components/ui/PickPartUi';
import CustomSelect from '../../../../../components/common/SelectField';
import { MenuItem, Stack } from '@mui/material';
import { getBackgroundByStatusValue } from '../../helpers/getBackgroundByStatusValue';
import TagSelector from '../../../storeSetup/common/Tags';
import { MdPlaylistAddCircle } from 'react-icons/md';
import { MdBlock } from 'react-icons/md';

function isPropsEqual(oldProps: any, newProps: any) {
  const prevValue = oldProps.rowData;
  const newValue = newProps.rowData;
  // Check if the item prop has changed using a deep comparison
  const itemEqual = lodash.isEqual(prevValue, newValue);
  // index comparison is necessary because react dont  know about the row which is to update
  return itemEqual && oldProps.index === newProps.index;
}

interface Iprops {
  index: any;
  rowData: any;
  isView: boolean;
  isReportLocked: boolean;
  handleChangeRow: any;
  handelDeleteRows: (rowIdx: number) => void;
  openModal: any;
  removePart: any;
  handleModalForLocation: any;
}

const TRow = memo(
  ({
    index,
    rowData,
    isView,
    handleChangeRow,
    handelDeleteRows,
    openModal,
    removePart,
    handleModalForLocation,
    isReportLocked,
  }: Iprops) => {
    const { _id } = rowData;
    const idLocked = _id ? true : false;
    // console.log(typeof isView, typeof idLocked);
    return (
      <tr>
        <td width={'100px'} style={{ fontWeight: 'bold' }}>
          {index + 1}
        </td>
        <td style={{ minWidth: '250px' }}>
          <PickPartUi
            data={rowData}
            removePart={removePart}
            addPart={() => openModal(index)}
            isView={isView || idLocked}
          />
        </td>
        <td>{rowData.part_id?.part_number || rowData.partNumber}</td>
        <td>
          <TableInput
            name="no_of_pkt_per_pcs"
            type="number"
            isView={isView || idLocked}
            value={rowData.no_of_pkt_per_pcs}
            onChange={(e) => {
              handleChangeRow(e, index);
            }}
          />
        </td>
        <td>
          <TableInput
            name="uom"
            type="text"
            isView={isView || idLocked}
            value={rowData.uom}
            onChange={(e) => {
              handleChangeRow(e, index);
            }}
          />
        </td>
        <td>
          <TableInput
            name="total_qty"
            type="number"
            isView={isView || idLocked}
            value={rowData.total_qty}
            onChange={(e) => {
              handleChangeRow(e, index);
            }}
          />
        </td>
        <td>
          <TableInput
            name="ok_qty"
            type="number"
            isView={isView || idLocked}
            value={rowData.ok_qty}
            onChange={(e) => {
              handleChangeRow(e, index);
            }}
          />
        </td>
        <td>{rowData.rej_qty}</td>
        <td
          style={{ minWidth: '450px', maxWidth: '500px', textAlign: 'center' }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <TagSelector
              tags={rowData?.location?.length > 0 ? rowData?.location : null}
              populateField={'compartment_id'}
              fieldName1="name"
              fieldName2="qty"
            />

            {isView || idLocked ? (
              <MdBlock style={{ fontSize: '2rem' }} />
            ) : (
              <CustomIconButton
                sx={{ pr: 0 }}
                tooltipTitle={'PICK Location'}
                onClick={() => {
                  handleModalForLocation(index);
                }}
              >
                <MdPlaylistAddCircle
                  style={{
                    fontSize: '30px',
                    color: '#f03e3e',
                    cursor: 'pointer',
                  }}
                />
              </CustomIconButton>
            )}
          </Stack>
        </td>
        <td
          style={{
            background:
              isView || idLocked
                ? getBackgroundByStatusValue(rowData.status)
                : '#fff',
          }}
        >
          {isView || idLocked ? (
            rowData.status
          ) : (
            <CustomSelect
              name="status"
              value={rowData.status}
              onChange={(e) => {
                handleChangeRow(e, index);
              }}
              sx={{ background: getBackgroundByStatusValue(rowData.status) }}
            >
              <MenuItem value="OK">OK</MenuItem>
              <MenuItem value="NG">NG</MenuItem>
              <MenuItem value="UNDER APPROVAL">UNDER APPROVAL</MenuItem>
            </CustomSelect>
          )}
        </td>
        <td>
          {isView || idLocked ? (
            <MdBlock style={{ fontSize: '2rem' }} />
          ) : (
            <DeleteIconButton
              tooltipTitle={'delete Row'}
              onClick={() => handelDeleteRows(index)}
            />
          )}
        </td>
      </tr>
    );
  },
  isPropsEqual
);

// isPropsEqual is false component rerender

export default TRow;
